import * as React from 'react';
import NetworkingType from '../../models/Networking';
import { AddressType } from '../../models/Address';
import Address from '../Address';
import './style.scss';
import Networking from '../Networking';
import Text from '../Text';
import { useTranslation } from 'react-i18next';

interface Props {
  networking: NetworkingType[];
  addresses: AddressType[];
  isLegacy?: boolean;
}

const Communication: React.SFC<Props> = ({
  networking,
  addresses,
  isLegacy = true,
}) => {
  const { t } = useTranslation();

  const classPrefix = isLegacy ? 'communication-legacy' : 'communication';
  return (
    <div className={classPrefix}>
      {!isLegacy && (
        <Text type="p" color="light" className="communication__title">
          {t('contact_form_contact')}
        </Text>
      )}
      <Networking networking={networking} isLegacy={isLegacy} />
      <Address addresses={addresses} isLegacy={isLegacy} />
    </div>
  );
};

export default Communication;
